import { Navigate, useLocation } from "react-router-dom";

import { RVNestedRoutingPage } from "@regal-voice/ui";
import { usePageAvailability } from "App/routes/Hooks/usePageAvilability/usePageAvailability";
import { createRerouteRegex } from "App/routes/pageNames";
import { AppPagePaths, LegacyPagePaths } from "App/routes/paths";

import { useOrchestrationPathing } from "../../useOrchestrationPathing";

export default function CampaignsRouter(): JSX.Element {
    const { orchestrationPages } = usePageAvailability();

    if (!orchestrationPages.showCampaigns) {
        return <Navigate to={AppPagePaths.fallback} />;
    }

    return <RVNestedRoutingPage />;
}

export function CampaignsRerouter(): JSX.Element {
    const location = useLocation();
    const { campaignsBasePath } = useOrchestrationPathing();
    const pathAfterCampaigns = location.pathname.replace(createRerouteRegex(LegacyPagePaths.campaigns), "");
    const newPath = pathAfterCampaigns
        ? `${campaignsBasePath}/${pathAfterCampaigns}${location.search}${location.hash}`
        : `${campaignsBasePath}${location.search}${location.hash}`;
    return <Navigate to={newPath} replace />;
}
